import i18next from "i18next"
import { Map } from "immutable"
import * as React from "react"
import { none, some } from "widgets-for-react"
import { decodeHTMLEntities, gtmPush } from "../../../../helpers"
import { visit_option } from "../../../../utils"
import { Form } from "../../../form"
import { WordPress } from "../../../wordpress/wordpress_api"
// import { Pagination } from "../pagination.mod"
import { BrochureWebshopState } from "./brochuresWebshop.widget"

interface BrochoreShopLayoutProps {
  s0: BrochureWebshopState
  onPropChange: <K extends keyof BrochureWebshopState>(key: K, value: BrochureWebshopState[K]) => void
  isDownload?: boolean
  isLoading?: boolean
}

export const BrochuresWebshopLayout = {
  ShoppingHeader: (props: { shopTitle: string, shopdescription: string }) => {
    return (
      <header className="brs__header">
        <h3 className="block__title brs__title typo--l ff--primary">{props.shopTitle}</h3>
        {props.shopdescription && <div className="brs__intro" dangerouslySetInnerHTML={{ __html: props.shopdescription }}></div>}
      </header>
    )
  },

  ShoppingCart: (props: BrochoreShopLayoutProps) => {
    const { s0, onPropChange } = props
    return (
      <aside className="brs__sidebar sidebar sbr">
        <h3 className="sbr__title ff--primary">
          <span>{i18next.t("shop.aside_title")}</span>
          <svg className="sbr__icon" height="23" width="24" aria-hidden="true">
            <use xlinkHref="#icon--cart" />
          </svg>
        </h3>
        {s0.shopping_cart.keySeq().toArray().length != 0 ? (
          <ul className="sbr__list amounts ams">
            {s0.shopping_cart
              .keySeq()
              .toArray()
              .map((k) => {
                const shop_item = s0.shopping_cart.get(k)!
                return (
                  <li className="ams__item typo--s fw--regular" key={k}>
                    {decodeHTMLEntities(shop_item.title)}
                    <span className="ams__quantity">
                      {shop_item.quantity}
                      {"x  "}
                    </span>
                  </li>
                )
              })}
          </ul>
        ) : (
          <p className="sbr__placeholder typo--s fw--regular">0 {i18next.t('shop.selected_items')}</p>
        )}
        {/* TODO: add translation */}
        {s0.step == "step 1 - catalog" && (
          <button
            className="sbr__button button button--primary"
            disabled={s0.shopping_cart.count() == 0}
            onClick={() => onPropChange("step", "step - 2 - form")}
          >
            {i18next.t("shop.place_order")}
          </button>
        )}
      </aside>
    )
  },

  StepOne: (props: BrochoreShopLayoutProps) => {
    const { s0, onPropChange, isLoading } = props
    const brochures: Map<string, WordPress.BrochureResponse> = s0.brochures
      .reduce((xs, x) => x.kind == 'loaded' ? xs.concat(x.value.items).toMap() : xs, Map<string, WordPress.BrochureResponse>())

    return (
      <div className="brs__brochures">
        {/* FIlters */}
        <select
          className="brs__dropdown dropdown typo--s"
          value={visit_option<number, number>(s0.selected_term)(
            (v) => v,
            () => -1
          )}
          onChange={(e) => {
            gtmPush({
              event: "filter", 
              filter_subject: e.currentTarget.value, 
              filter_selection: e.currentTarget.value,                 
          })
            onPropChange(
              "selected_term",
              Number(e.currentTarget.value) < 0 ? none() : some(Number(e.currentTarget.value))
            )
          }
          }
        >
          <option value={-1}>{i18next.t("shop.filter")}</option>
          {s0.terms.kind == "loaded" &&
            s0.terms.value.map((t) => (
              <option key={t.id} value={t.id}>
                {decodeHTMLEntities(t.name)}
              </option>
            ))}
        </select>
        {s0.shopping_cart.keySeq().toArray().length != 0 ? (
          <ul className="brs__list ams">
            {s0.shopping_cart
              .keySeq()
              .toArray()
              .map((k) => {
                const shop_item = s0.shopping_cart.get(k)!
                return (
                  <li className="ams__item typo--s fw--regular" key={k}>
                    {shop_item.title}
                    <span className="ams__quantity">
                      {shop_item.quantity}
                      {"x  "}
                    </span>
                  </li>
                )
              })}
          </ul>
        ) : (
          <p className="brs__placeholder typo--s fw--regular">0 items selected</p>
        )}


        {/*Product catalog */}
        <ul className="brs__grid">
          {brochures
            .toIndexedSeq()
            .toArray()
            .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
            .map((item) => {
              const current_quantity = s0.shopping_cart.has(item.id.toString())
                ? s0.shopping_cart.get(item.id.toString()).quantity
                : 0

              return (
                <li className="brochure br" key={item.id} id={`brochure-${item.id}`}>
                  <div className="br__visual">
                    <div className="br__visual-inner fit-object">
                      <img
                        className="br__img"
                        src={item.acf.image.url}
                        height={320}
                        width={320}
                        alt={item.acf.image.alt ? item.acf.image.alt : ""}
                      />
                    </div>
                  </div>
                  <h2 className="br__title ff--primary typo--m">{decodeHTMLEntities(item.title.rendered)}</h2>
                  <div
                    className="br__intro typo--s text--styled"
                    dangerouslySetInnerHTML={{ __html: item.acf.description }}
                  />
                  <footer className="br__footer">
                    {!props.isDownload && Number(item.acf.max_quantity) > 0 ? (
                      <input
                        className="br__selection"
                        min={0}
                        max={Number(item.acf.max_quantity) == 0 ? undefined : item.acf.max_quantity}
                        placeholder='0'
                        onChange={(e) => {
                          if (
                            (Number(e.currentTarget.value) <= Number(item.acf.max_quantity) ||
                              Number(item.acf.max_quantity) == 0) &&
                            Number(e.currentTarget.value) >= 0
                          ) {
                            onPropChange(
                              "shopping_cart",
                              Number(e.currentTarget.value) == 0
                                ? s0.shopping_cart.delete(item.id.toString())
                                : s0.shopping_cart.set(item.id.toString(), {
                                  quantity: Number(e.currentTarget.value),
                                  title: item.title.rendered,
                                  product_id: item.acf.product_number,
                                })
                            )
                          }
                        }}
                        value={s0.shopping_cart.has(item.id.toString()) ? s0.shopping_cart.get(item.id.toString()).quantity : 0}
                        type="number"
                      />) : <span></span>}
                    <a className="br__link typo--s fw--regular" download href={item.acf.download} target="_blank">
                      {i18next.t("shop.download")}
                    </a>
                    {current_quantity >= Number(item.acf.max_quantity) && Number(item.acf.max_quantity) != 0 && (
                      <p className="br__warning typo--s fw--regular">{i18next.t("shop.max")}</p>
                    )}
                  </footer>
                </li>
              )
            })}
        </ul>

        {/* {s0.total_pages.v.kind == "r" && (
          <Pagination
            pager={{
              current_page: s0.current_page,
              items_per_page: s0.size,
              total_items: s0.total_items,
              total_pages: s0.total_pages.v.v,
            }}
            setPage={(page) => onPropChange("current_page", page)}
          />
        )} */}
      </div>
    )
  },

  StepTwo: (props: BrochoreShopLayoutProps) => {
    const { s0, onPropChange } = props

    return (
      <div className="block block--form">
        <div className="block__inner">
          <div className="block__content">
            <h2 className="block__title typo--l ff--primary">{i18next.t(`shop.${s0.form.form_submission_logic.kind == 'loaded' && s0.form.form_submission_logic.value == 'ok' ? 'thanks' : 'form'}`)}</h2>

            {Form(s0.form).run((a) => onPropChange("form", a(s0.form)))}

            {s0.form.form_submission_logic.kind == "unloaded" && (
              <button
                className="block__button button button--secondary"
                onClick={() => onPropChange("step", "step 1 - catalog")}
              >
                {i18next.t("shop.prev")}
              </button>
            )}
          </div>
        </div>
      </div>
    )
  },
}
